module.exports = __webpack_public_path__ + "static/img/LIAM-HETHERTON.5968616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LIAM-HETHERTON.jpg
// module id = xLpE
// module chunks = 0